import { render, staticRenderFns } from "./stockTransferList.vue?vue&type=template&id=7144dcd1"
import script from "./stockTransferList.vue?vue&type=script&lang=js"
export * from "./stockTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports